import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reactLocalStorage } from 'reactjs-localstorage';
import { Redirect } from 'react-router-dom';
import { checkPageAuthorization } from './actions/auth/AuthActions'
import { loggedInUserId } from './helper';
import { ALL_NEED_FORM, ANNUAL_KYS_REQUEST, APPROVAL_APP, MASTER_UPDATE_REQUESTS, NEW_SUPPLIER_REQUEST, Simulation_Page } from './config/constants';

export default function AuthMiddleware(ComposedComponent, PAGENAME) {
    class AuthMiddleware extends Component {

        constructor(props) {
            super(props);
            this.state = {
                redirectToLogin: false,
            }
        }

        UNSAFE_componentWillMount() {
            const queryParams = new URLSearchParams(window.location.search);
            const isMobileDevice = queryParams.get("md");
            if (this.props.authenticated === false && isMobileDevice === "true") {
                const urlPart = window.location.pathname + window.location.search;
                // reactLocalStorage.setObject("mdurl", urlPart);
                localStorage.setItem("mdurl", urlPart);
            } else if (this.props.authenticated === true) {
                // reactLocalStorage.remove("mdurl");
                localStorage.removeItem("mdurl");
            }

            // CONDITION TO CHECK IF USER LOGGED IN THEN CONTINUE, OTHERWISE REDIRECT TO LOGIN PAGE
            if (this.props.authenticated === false) {
                this.setState({ redirectToLogin: true })
                return false;
            }

            // CONDITION  TO CHECK REQUEST (PAGE OR URL) IS ACCESSIBLE OR NOT1
            if (this.props.authenticated === true) {
                console.log("PAGENAME", PAGENAME)
                    let reqData = {
                        PageName: PAGENAME,
                        LoggedInUserId: loggedInUserId(),
                        ReceiverId: (PAGENAME===Simulation_Page||PAGENAME===APPROVAL_APP || PAGENAME===ALL_NEED_FORM || PAGENAME===MASTER_UPDATE_REQUESTS || PAGENAME===ANNUAL_KYS_REQUEST || PAGENAME===NEW_SUPPLIER_REQUEST)?reactLocalStorage.getObject('receiverId'):null
                }
                this.props.checkPageAuthorization(reqData, res => {
                    if (res && res.status === 401 && res.statusText === 'Unauthorized') {
                        //NEW ADDED FOR (DISABLED THIS IF ANY ERROR)
                        // reactLocalStorage.setObject("isUserLoggedIn", false);
                        // reactLocalStorage.setObject("userDetail", {});
                        // reactLocalStorage.set('ModuleId', '');
                        // this.setState({ redirectToLogin: true })
                    }
                })
            }
        }

        render() {

            if (this.state.redirectToLogin === true) {
                return <Redirect to={'/login'} />
            }

            //Render the component with all props
            return <ComposedComponent {...this.props} />
        }
    }

    /**
     * Assign user's authentication status
     * @returns {{authenticated: *}}
     */
    function mapStateToProps() {
        let isAuthenticated;

        if (reactLocalStorage.getObject("isUserLoggedIn") === true) {
            isAuthenticated = true;
        } else {
            isAuthenticated = false;
        }

        return {
            authenticated: isAuthenticated,
        }
    }

    /**
    * @method connect
    * @description connect with redux
    * @param {function} mapStateToProps
    * @param {function} mapDispatchToProps
    */
    return connect(mapStateToProps, { checkPageAuthorization })(AuthMiddleware);
}